<template>
  <b-card
    align="center"
    no-body class="overflow-hidden" style="max-width: 540px;">
  <b-row>
    <b-col md="6">
      <b-card-body>
        <b-card-img :src="image_item.attributes['image-url']" alt="Image" class="rounded-0"></b-card-img>
      </b-card-body>
    </b-col>
    <b-col md="6">
      <b-card-body :title="rating">
        <b-card-text>
          {{comment}}
        </b-card-text>
      </b-card-body>
    </b-col>
  </b-row>
  </b-card>
</template>

<script>
export default {
  props: {
    data_item: {
      Type: Object
    },
    image_item: {
      Type: Object
    },
    product_item: {
      Type: Object
    }
  },
  computed: {
    comment() {
      return this.data_item.attributes['comment'] || "No Comment"
    },
    rating() {
      return this.data_item.attributes['item-image-rating']
    }
  }
}
</script>
